import { createFileRoute } from "@tanstack/react-router";

import { RoutingImport } from "../../../features/routing-import/components/routing-import";

/**
 * `RPM-104`'s import page (`J-488`): the crosswalk candidates, the bundle, its dry run and its apply.
 * The server decides who may import (`routing: ["import"]` at tenant scope).
 */
function RoutingImportScreen() {
  return <RoutingImport />;
}

export const Route = createFileRoute("/_authenticated/admin/routing-import")({
  component: RoutingImportScreen,
  staticData: { screenName: "Routing import" },
});
